'use client';

import classNames from 'classnames';
import SwiperCarousel from '@alltrails/denali/components/SwiperCarousel';
import { Image, useWindowSize } from '@alltrails/core';
import styles from './styles/styles.module.scss';
import type { ImageData } from '@/types/shared';

type PostPhotoSlideshowProps = {
  uniqueId: string;
  imgData: ImageData[];
  postTitle: string;
};

const PostPhotoSlideshow = ({ uniqueId, imgData, postTitle }: PostPhotoSlideshowProps) => {
  const { width } = useWindowSize();
  const size = width > 1440 ? 1440 : width;

  const anyImageHasACaption = imgData.some(img => img.caption);

  return (
    <SwiperCarousel
      uniqueId={uniqueId}
      items={imgData}
      renderItem={img => (
        <figure className={styles.figure}>
          <Image src={img.src} alt={img.caption || postTitle} loading="lazy" width={size} height={size} className={styles.image} />
          {img.caption && <figcaption className={styles.caption}>{img.caption}</figcaption>}
        </figure>
      )}
      getItemKey={imgData => `slideshow-img-${imgData.src}`}
      arrowStyle="subtle-with-standard-arrows"
      loop
      showPaginationDots
      hideSlideOverflow
      className={classNames(styles.container, { [styles.hasCaption]: anyImageHasACaption })}
    />
  );
};

export default PostPhotoSlideshow;
